module.exports = __webpack_public_path__ + "res/r-logo-gold.7f35c77cda6d6bd41604d413a95f7131.png";